import React, { useState, useEffect } from "react";
import { Input, FormFeedback, Tooltip } from "reactstrap";

const NameInput = ({
    label = "Name",
    placeholder = "Enter your name",
    required = false,
    layout = "below",
    value = "",
    name = "name",
    id = "nameInput",
    onChange = () => {},
    onBlur = () => {},
    requiredErrorMessage = "This field is required.",
    validationErrorMessage = "Name must be at least 3 characters and contain only letters.",
    showHelp = false,
    helpText = "Please enter your name.",
    validateTrigger, // Trigger for validation on form submission
}) => {
    const [inputValue, setInputValue] = useState(value);
    const [errors, setErrors] = useState({});
    const [tooltipOpen, setTooltipOpen] = useState(false);

    useEffect(() => {
        setInputValue(value); // Set inputValue when value prop changes
    }, [value]);

    const capitalizeFirstLetter = (val) => {
        return val.charAt(0).toUpperCase() + val.slice(1);
    };

    const validateInput = (val) => {
        const trimmedVal = val.replace(/\s/g, ""); // Remove all spaces from the value
        const newErrors = {};
    
        if (required && !trimmedVal) {
            newErrors.required = requiredErrorMessage;
        } else if (trimmedVal.length < 3 || !/^[A-Za-z]+$/.test(trimmedVal)) {
            newErrors.validation = validationErrorMessage;
        }
    
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    
    

    const handleInputChange = (e) => {
        const capitalizedValue = capitalizeFirstLetter(e.target.value);
        setInputValue(capitalizedValue);
        
        // Call Formik's onChange to update Formik state
        onChange({
            target: {
                name: name,
                value: capitalizedValue,
            },
        });
    };

    const handleInputBlur = (e) => {
        validateInput(e.target.value);
        onBlur(e);
    };

    useEffect(() => {
        if (validateTrigger) {
            validateInput(inputValue);
        }
    }, [validateTrigger, inputValue]);

    return (
        <div className={layout === "inline" ? "d-flex align-items-center mb-2" : "mb-2"}>
            <label htmlFor={id} className="d-flex" style={{ width: layout === "inline" ? "25%" : "100%" }}>
              <span>
                {label}
                {required && <span className="text-danger ml-1">*</span>}
                {showHelp && (
                    <span id={`helpTooltip-${id}`} className="ms-1"
                    style={{  position: "relative", top: "-3px" }}
>
                        <i className="ri-question-line" style={{ cursor: 'pointer', fontSize: '16px' }}></i>
                    </span>
                )}
                </span>
            </label>
            {showHelp && (
                <Tooltip
                    placement="right"
                    isOpen={tooltipOpen}
                    target={`helpTooltip-${id}`}
                    toggle={() => setTooltipOpen(!tooltipOpen)}
                >
                    {helpText}
                </Tooltip>
            )}
            <div className="w-100">
                <Input
                    type="text"
                    name={name}
                    id={id}
                    placeholder={placeholder}
                    value={inputValue}
                    onChange={handleInputChange}
                    onBlur={handleInputBlur}
                    invalid={!!errors.required || !!errors.validation}
                />
                {errors.required && <FormFeedback type="invalid">{errors.required}</FormFeedback>}
                {errors.validation && <FormFeedback type="invalid">{errors.validation}</FormFeedback>}
            </div>
        </div>
    );
};

export default NameInput;



// /* eslint-disable react/prop-types */
// import React, { useState, useEffect } from "react";
// import { Input, FormFeedback, Tooltip } from "reactstrap";

// const NameInput = ({
//     label = "Name", 
//     placeholder = "Enter your name", 
//     required = false, 
//     layout = "below", // Default layout (inline or below)
//     value = "", 
//     name = "name", 
//     id = "nameInput", 
//     onChange, 
//     onBlur, 
//     requiredErrorMessage = "This field is required.",
//     validationErrorMessage = "Name must be at least 3 characters and contain only letters.",
//     showHelp = false,
//     helpText = "Please enter your name.", 
//     form, // Add Formik's form prop for error handling
// }) => {
//     const [inputValue, setInputValue] = useState(value); 
//     const [errors, setErrors] = useState({}); 
//     const [tooltipOpen, setTooltipOpen] = useState(false);
//     const [touched, setTouched] = useState(false); // Track if the input has been touched

//     // Update inputValue when Formik's value changes
//     useEffect(() => {
//         setInputValue(value);
//         if (touched) {
//             validateInput(value); // Validate the new value from Formik if touched
//         }
//     }, [value, touched]); // Include touched in the dependency array

//     // Helper function to capitalize the first letter
//     const capitalizeFirstLetter = (value) => {
//         if (value && value.length > 0) {
//             return value.charAt(0).toUpperCase() + value.slice(1);
//         }
//         return value;
//     };

//     // Validation function to check if input is valid
//     const validateInput = (value) => {
//         const newErrors = {};
//         if (required && !value) {
//             newErrors.required = requiredErrorMessage;
//         } else if (value && (value.length < 3 || !/^[A-Za-z]+$/.test(value))) {
//             newErrors.validation = validationErrorMessage;
//         }

//         // Update the Formik form errors state
//         form.setFieldError(name, newErrors.required || newErrors.validation);
        
//         setErrors(newErrors);
//         return Object.keys(newErrors).length === 0; // Return true if no errors
//     };

//     // On change handler that ensures the first letter is capitalized and validates input
//     const handleInputChange = (e) => {
//         const capitalizedValue = capitalizeFirstLetter(e.target.value);
//         setInputValue(capitalizedValue); 
//         validateInput(capitalizedValue);
//         onChange(e); // Call the passed onChange function
//     };

//     // On blur, validate the input and mark as touched
//     const handleInputBlur = (e) => {
//         setTouched(true); // Mark the input as touched
//         validateInput(e.target.value);
//         onBlur(e); // Call the passed onBlur function
//     };

//     return (
//         <div className={layout === "inline" ? "d-flex align-items-center mb-2" : "mb-2"}>
//             <label htmlFor={id} className="d-flex" style={{ width: layout === "inline" ? "25%" : "100%" }}>
//                 {label}
//                 {required && <span className="text-danger ml-1">*</span>} 
//                 {showHelp && (
//                     <span id="helpTooltip" className="px-2">
//                         <i
//                             className="ri-question-line"
//                             style={{ cursor: 'pointer', fontSize: '16px' }}
//                         ></i>
//                     </span>
//                 )}
//             </label>
//             {showHelp && (
//                 <Tooltip
//                     placement="right"
//                     isOpen={tooltipOpen}
//                     target="helpTooltip"
//                     toggle={() => setTooltipOpen(!tooltipOpen)}
//                 >
//                     {helpText}
//                 </Tooltip>
//             )}
//             <div className="w-100">
//                 <Input
//                     type="text"
//                     name={name} 
//                     id={id} 
//                     placeholder={placeholder}
//                     value={inputValue} 
//                     onChange={handleInputChange} 
//                     onBlur={handleInputBlur} 
//                     invalid={!!errors.required || !!errors.validation} 
//                 />
//                 {errors.required && (
//                     <FormFeedback type="invalid">
//                         {errors.required}
//                     </FormFeedback>
//                 )}
//                 {errors.validation && (
//                     <FormFeedback type="invalid">
//                         {errors.validation}
//                     </FormFeedback>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default NameInput;
